module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/employees/Employee.ejs -->\n<td>'+
((__t=( model.get('fullName') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('email') ))==null?'':_.escape(__t))+
'</td>\n<td>\n    '+
((__t=( company ? company.get('companyName') : '-' ))==null?'':_.escape(__t))+
'\n</td>\n<td>'+
((__t=( user ? moment(user.get('createdAt')).format('DD/MM/YYYY') : '-' ))==null?'':_.escape(__t))+
'</td>\n<td>\n    ';
 if (displayLogin) { 
__p+='\n        <a href="" class="js-login" title="Login as Employee">\n            <i class="fa fa-2x fa-sign-in"></i>\n        </a>\n    ';
 } 
__p+='\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/employees/Employee.ejs
// module id = 675
// module chunks = 1